import React from 'react';
import { Box, Button, CardActions, CardContent, Feedback, Grid, Paper, Typography } from '@availity/element';

import { AvailityHeaderLogo, Footer } from '@/components';
import { useAppContext } from '@/context';
import { handleSuccessNavigation } from '@/global';

// page should only render if user submitted any admin changes
const OAAFeedback = () => {
  const { queryParams, userHasInvites } = useAppContext();
  const { goto } = queryParams;

  // handle continue logic
  const handleContinue = () => handleSuccessNavigation(goto, userHasInvites);

  return (
    <Grid
      id="oaa-feedback-page-grid-container"
      container
      display="flex"
      flexDirection="row"
      flexWrap="wrap"
      spacing={0}
      sx={{ minHeight: '100vh', justifyContent: 'center' }}
    >
      <Grid size={{ xs: 12, sm: 12, md: 6 }} display="flex" flexDirection="column" alignItems="center" flexGrow={1}>
        <AvailityHeaderLogo />
        <Grid direction="column" alignItems="center" justifyContent="center">
          <Paper variant="elevation" elevation={6} sx={{ width: { xs: '350px', sm: '500px', md: '700px' } }}>
            <CardContent>
              <Typography variant="h1" mb={2}>
                Your request has been submitted.
              </Typography>
              <Box mb={1}>
                <Typography variant="subtitle1">
                  Please allow 7-10 business days for this request to be processed.
                </Typography>
              </Box>
              <Typography variant="subtitle1">
                You will receive an email confirmation and you can check for status updates under{' '}
                <Box component="span" sx={{ fontWeight: 'bold' }}>
                  My Account &gt; My Tickets
                </Box>
                .
              </Typography>
            </CardContent>
            <CardActions sx={{ justifyContent: 'space-between', marginTop: 3 }}>
              <Feedback appName="registration-administration" buttonVariant="tertiary" />
              <Button color="primary" onClick={handleContinue}>
                Continue
              </Button>
            </CardActions>
          </Paper>
        </Grid>
      </Grid>
      <Footer />
    </Grid>
  );
};

export default OAAFeedback;
